import { render, staticRenderFns } from "./AddTable.vue?vue&type=template&id=18150d47&scoped=true"
import script from "./AddTable.vue?vue&type=script&lang=js"
export * from "./AddTable.vue?vue&type=script&lang=js"
import style0 from "./AddTable.vue?vue&type=style&index=0&id=18150d47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18150d47",
  null
  
)

export default component.exports